import * as angular from 'angular';
import { StateParams, StateService } from '@uirouter/angularjs';
import { UrlService } from '../../services/url.service';

function directive($rootScope: ng.IRootScopeService, $state: StateService, $stateParams: StateParams, urlService: UrlService, $window: ng.IWindowService ) {

    return {
        restrict: 'A',
        template: require('./video.directive.html'),
        require: 'ngModel',
        scope: {
            ngModel: '=',
            identifier: '=',
            fixedWidth: '=?',
            maxWidth: '=?',
            maxHeight: '=?',
            autoinit: '=?',
            autoplay: '=?',
            videoContainer : '=?'
        },
        link: function ($scope: ng.IScope & any, element: JQLite, attrs: ng.IAttributes, ctrl: ng.IController) {
            $scope.video = $scope.ngModel;
            $scope.htmlElementID = $scope.identifier;
            $scope.videoContainer = ($scope.videoContainer) ? $scope.videoContainer : '#videoContainer';

            $scope.getPlayerHeight = (fixedWidth: number) => {
                if (!fixedWidth) {
                    fixedWidth = 870; // dashboard max
                }

                if (!$scope.maxHeight) {
                    $scope.maxHeight = fixedWidth * 1.25;
                }

                var minHeight = fixedWidth * 0.5;

                var width = $scope.video.Width;
                var height = $scope.video.Height;

                var newHeight: number;

                if (width > height) {
                    var ratio = width / fixedWidth;
                    newHeight = height / ratio;
                } else {
                    newHeight = height;
                }

                if (newHeight > $scope.maxHeight) {
                    newHeight = $scope.maxHeight;
                } else if (newHeight < minHeight) {
                    newHeight = minHeight;
                }

                return newHeight;
            };

            $scope.getVideoWidth = () => {
                var width = $($scope.videoContainer).width();
                return width > $scope.maxWidth ? $scope.maxWidth : width;
            };

            $scope.resizePlayer = () => {
                var width = $scope.getVideoWidth();
                if (width) {
                    $scope.fixedWidth = width;
                    $scope.currentHeight = $scope.getPlayerHeight(width);
                }
            };

            if (!$scope.fixedWidth) {
                var w = angular.element($window);
                $scope.getWindowDimensions = function () {
                    return {
                        'h': w.height(),
                        'w': w.width()
                    };
                };
                $scope.$watch($scope.getWindowDimensions, function (newValue: any, oldValue: any) {
                    $scope.resizePlayer();
                }, true);

                $scope.$watch(() => { return $scope.getVideoWidth(); }, (newValue: any, oldValue: any) => {
                    $scope.resizePlayer();
                }, true);

                w.bind('resize', function () {
                    $scope.$apply();
                });

                $scope.resizePlayer();
            }

            $scope.currentHeight = $scope.getPlayerHeight($scope.fixedWidth);

            $scope.selfUrl = $state.href($state.current.name, $stateParams, { absolute: true });

            if (typeof $scope.autoinit === 'undefined') {
                $scope.autoinit = false;
            }

            if (typeof $scope.autoplay === 'undefined') {
                $scope.autoplay = true;
            }

            $scope.videoPlayerLoaded = false;

            $scope.initVideoPlayer = () => {
                var videoUrl = $scope.video.VideoUrl || $scope.video.TeaserUrl;

                if (videoUrl && !$scope.videoPlayerLoaded) {

                    var htmlElementID = $scope.video.ID + (($scope.htmlElementID) ? ('_' + $scope.htmlElementID) : '');

                    var videoElement = element[0].querySelector('#video');
                    if (videoElement != null) {
                        videoElement.insertAdjacentHTML('afterend',
                            '<iframe id="videoplayer_' + htmlElementID + '" src="https://ampdemo.azureedge.net/azuremediaplayer_embed.html?url=' +
                            encodeURIComponent(videoUrl) +
                            (($scope.video.ThumbnailUrl && !$scope.autoplay) ? '&poster=' + encodeURI($scope.video.ThumbnailUrl) : '') +
                            ($scope.autoplay ? '&autoplay=true"' : '&autoplay=false"') +
                            ' name="azuremediaplayer" scrolling="no" frameborder="no" align="center" width="100%" height="100%" allowfullscreen></iframe>');
                        $scope.videoPlayerLoaded = true;
                    }
                }
            };

            if ($scope.autoinit) {
                $scope.initVideoPlayer();
            }
        }
    };
}

angular.module('app.common').directive('video', directive); // TODO rework to component

directive.$inject = ['$rootScope', '$state', '$stateParams', 'urlService', '$window'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/video/video.directive.ts